import React from 'react';
import { Link } from 'react-router-dom';

import { useEffect } from 'react';
const TermsPage = () => {
    useEffect(() => {
  // גלילה חלקה לראש העמוד
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, []);
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-6 sm:p-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6 text-center">תנאי שימוש באתר</h1>
          <p className="text-gray-700 text-center mb-6">עודכן לאחרונה: יולי 2025</p>

          <div className="prose prose-lg max-w-none text-right" dir="rtl">
            <p className="text-gray-700 leading-relaxed mb-6">
              תנאי שימוש אלה ("התנאים") מהווים הסכם משפטי מחייב בין המשתמש ("המשתמש", "אתה") לבין מפעיל האתר ("האתר", "מפעיל האתר", "אנחנו"), והם חלים על כל שימוש שתעשה באתר האינטרנט "גמלנט AI", לרבות השירותים, התכנים, האלגוריתמים, הנתונים, והמידע הנכללים או ניתנים באמצעותו, בין אם נגישים כיום ובין אם יונגשו בעתיד.
            </p>
            <p className="text-gray-700 leading-relaxed mb-6">
              השימוש באתר כפוף להסכמתך המפורשת והמלאה לכל הוראות התנאים, לרבות כל מסמך משפטי נלווה (כגון מדיניות פרטיות, דיסקליימר, מדיניות ביטולים וכו'). אנא קרא את התנאים בקפידה לפני כל שימוש באתר. אם אינך מסכים לאחד או יותר מהתנאים – אינך רשאי לעשות כל שימוש באתר.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">1. הגדרות</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              לצורך תנאים אלה:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4 pr-6">
              <li>
                <strong>"האתר"</strong> – אתר "גמלנט AI", הכולל מערכת ההשוואה Savings Comparison System המופעלת בכתובת <a href="https://gemelnet.ai" className="text-blue-600 hover:text-blue-800">https://gemelnet.ai</a>, וכל תת־הדומיינים או השירותים הנלווים לה.
              </li>
              <li>
                <strong>"מפעיל האתר"</strong> – לרבות בעל/י הזכויות, מתכנני המערכת, נותני השירותים, מנהלים, עובדים, סוכנים, יועצים וכל מי שפועל מטעמם.
              </li>
              <li>
                <strong>"משתמש"</strong> – כל אדם הגולש לאתר או עושה בו שימוש, בכל אמצעי טכנולוגי שהוא, בין אם כמשתמש מזוהה ובין אם לא.
              </li>
              <li>
                <strong>"השירות"</strong> – כל שירות מידע, תוכן, ניתוח, דירוג, הצגה, או כלי המשולבים באתר, לרבות אלגוריתם הדירוג וההשוואה.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">2. מהות האתר</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                האתר מהווה פלטפורמה להצגת מידע אינפורמטיבי השוואתי אודות מסלולי השקעה וחיסכון בישראל, לרבות קופות גמל, קרנות השתלמות, גמל להשקעה, קרנות פנסיה, פוליסות חיסכון וחיסכון לכל ילד.
              </li>
              <li>
                ההשוואה מבוצעת באמצעות אלגוריתם ניתוח פנימי, אשר מדרג מסלולים מתוך מקורות ציבוריים (כגון גמל-נט, פנסיה-נט, ביטוח-נט), בהתאם למשתנים כגון תשואה מצטברת, מדדי סיכון (Sharpe Ratio), רמות חשיפה למניות וטווחי זמן.
              </li>
              <li>
                אין בהצגת המידע משום מתן ייעוץ השקעות, שיווק השקעות, ייעוץ פנסיוני, ייעוץ מס או כל ייעוץ אחר, כמשמעותם בחוק הסדרת העיסוק בייעוץ השקעות, התשנ"ה–1995.
              </li>
              <li>
                האתר אינו מספק שירותים בתשלום למשתמש הקצה, ואינו יוצר כל יחסי לקוח־נותן שירות. המידע מוצג כמות שהוא (AS IS), ואינו מותאם אישית.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">3. שימוש מותר באתר</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                המשתמש מצהיר כי הינו בן 18 ומעלה, וכשיר מבחינה משפטית להתקשר בתנאים אלו.
              </li>
              <li>
                השימוש באתר מותר אך ורק לצרכים פרטיים ואישיים. אין לעשות בו שימוש לכל צורך מסחרי, אנליטי, ייעוצי או מקצועי – לרבות מטעם גוף עסקי, מוסדי או ציבורי – אלא בהיתר מראש ובכתב ממפעיל האתר.
              </li>
              <li>
                המשתמש מתחייב להימנע מביצוע כל פעולה אשר עלולה לפגוע באתר, בתפעולו, בבטיחותו, במשתמשים אחרים, בזכויות צדדים שלישיים או במוניטין מפעיל האתר, לרבות:
                <ul className="list-disc list-inside text-gray-700 space-y-2 pr-6 mt-2">
                  <li>העתקה או כרייה של נתונים</li>
                  <li>עקיפת מנגנוני אבטחה</li>
                  <li>ביצוע reverse engineering</li>
                  <li>יצירת מסדי נתונים מקבילים</li>
                  <li>הרצת תוכנות אוטומטיות / סקריפטים</li>
                </ul>
              </li>
              <li>
                מפעיל האתר שומר לעצמו את הזכות לחסום כל משתמש לפי שיקול דעתו הבלעדי וללא צורך בהנמקה, ככל שיתקיים חשש לשימוש אסור או מזיק.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">4. מסירת פרטים ומידע אישי</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                השימוש באתר עשוי לדרוש הזנת פרטים אישיים כגון שם מלא, טלפון, ודוא"ל – בין היתר לצורך יצירת קשר, קבלת ניתוחים או הצגת תכנים מותאמים.
              </li>
              <li>
                המשתמש מצהיר כי כל פרט שיימסר על ידו הינו נכון, מדויק, עדכני ומלא.
              </li>
              <li>
                מסירת פרטים באתר אינה מקנה למשתמש כל זכות לקבלת שירות, התחייבות מצד מפעיל האתר, או תוצאה מסוימת – אלא כפופה לשיקול דעת מלא של המפעיל.
              </li>
              <li>
                המידע שנמסר נשמר במאגרי נתונים חיצוניים (כגון Firebase ו־Google Sheets), ומנוהל לפי מדיניות הפרטיות של האתר.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">5. שמירת מידע, אבטחה וגישה</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                האתר עושה שימוש באמצעי אבטחה מקובלים לצורך שמירת מידע, אך המשתמש מצהיר כי הוא מודע לכך ששום מערכת אינה חסינה לחלוטין.
              </li>
              <li>
                מפעיל האתר אינו אחראי לדליפת מידע, חשיפתו, שינויו או מחיקתו עקב גישה בלתי מורשית, חדירה, תקלה, שיבוש, או כל מקרה שאינו בשליטתו הישירה.
              </li>
              <li>
                המשתמש מסכים לכך שהשימוש באתר כרוך בסיכונים, וכי הוא מוותר על כל טענה בנוגע לאובדן מידע, פגיעה בפרטיות או נזק טכנולוגי מכל סוג.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">6. התחייבויות המשתמש</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              המשתמש מצהיר ומתחייב בזאת כי:
            </p>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                לא יפר את הוראות כל דין, רגולציה או הסכם מחייב בעת השימוש באתר.
              </li>
              <li>
                לא יעשה שימוש מסחרי, מוסדי או מטעם גוף שלישי, ללא אישור מוקדם.
              </li>
              <li>
                לא ינסה לאסוף, לשכפל, לנתח, לשדר, להפיץ או למסחר מידע כלשהו מהאתר – לרבות דירוגים, מבנה אלגוריתמי, שמות שדות, טבלאות, גרפים, סמלים, טקסטים, או הצגת תוכן.
              </li>
              <li>
                ישפה את מפעיל האתר בגין כל נזק, תביעה, הוצאה או אחריות שתיגרם עקב הפרה של תנאים אלה או שימוש אסור.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">7. זכויות קניין רוחני</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                כל זכויות הקניין הרוחני באתר, בתוכנו, בעיצובו, במידע הכלול בו, בשירותים, בממשק, באלגוריתם, בתצוגה, באייקונים, ובכל רכיב טכנולוגי, תוכני, טקסטואלי או חזותי – שייכות באופן בלעדי למפעיל האתר.
              </li>
              <li>
                אין לראות בכל שימוש באתר, לרבות גישה, ניווט או הצגת תכנים – כהענקה מכל סוג של רישיון, זכות שימוש או העתקה – בין אם זמנית, חלקית או לצרכים אישיים.
              </li>
              <li>
                מובהר כי הנתונים המוצגים באתר עשויים להתבסס על מקורות ציבוריים (למשל גמל-נט), אך האופן שבו הם נאספים, מעובדים, מסוננים, מדורגים, מדוּוחים או מתורגמים להצגה ויזואלית – מהווה יצירה מקורית ובלעדית.
              </li>
              <li>
                המשתמש מתחייב שלא להעתיק, להפיץ, לשכפל, להציג בפומבי, להנדס לאחור, לפרסם, לתרגם, להחכיר, למכור או להשתמש בכל צורה שהיא בתכני האתר, כולו או חלקו, לרבות נתונים, טקסט, עיצוב, מבנה ניווט, טבלאות, גרפים, קוד, אלגוריתם, ממשקים, שמות קטגוריות, לוגואים, מדדים או כל רכיב אחר – ללא אישור בכתב ומראש ממפעיל האתר.
              </li>
              <li>
                האלגוריתם הקנייני שבבסיס המערכת – אשר מדרג את המסלולים הפיננסיים בהתאם למשתני סיכון, תשואה, חשיפה מנייתית ופרמטרים נוספים – מהווה יצירה מקורית וייחודית אשר מוגנת בזכויות יוצרים, סוד מסחרי, וחוק עוולות מסחריות. כל ניסיון לשכפל, להסיק, לחקות, או לבצע פעולה כלשהי לגביו – ייחשב כהפרת זכויות קניין רוחני ברמה החמורה ביותר.
              </li>
              <li>
                כל שימוש מפר בזכויות כאמור מהווה עילה לתביעה משפטית בגין הפרת זכויות יוצרים, הפרת סוד מסחרי, עוולה מסחרית, עשיית עושר ולא במשפט, ואף הפרת חובה חקוקה.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">8. מדדים, ניתוחים ואלגוריתמיים מיוחדים</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              האתר עשוי להציג למשתמשים מדדים, דירוגים, תובנות או השוואות המתקבלות באמצעות אלגוריתם ייחודי שפותח על ידי מפעיל האתר.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              מובהר בזאת כי כל לוגיקת הדירוג, נוסחאות השקלול, סדרי ההצגה, וכל תוצאה המתקבלת ממנגנוני ניתוח אלו – מהווים סוד מסחרי, יצירה מקורית או ביטוי ייחודי של ידע ופעולה, אשר מוגנים לפי דיני זכויות יוצרים, סודות מסחריים ודיני עשיית עושר ולא במשפט.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              חל איסור מוחלט לעשות שימוש חוזר, שכפול, הפצה, פרסום, הטמעה, כריית מידע (Scraping), יצירת תוצר נגזר, או כל פעולה אחרת במידע זה – ללא קבלת אישור מראש ובכתב ממפעיל האתר.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              כל שימוש לא מורשה כאמור עלול להוות הפרה של זכויות הקניין הרוחני של מפעיל האתר, ולהוביל לנקיטת הליכים משפטיים, לרבות בקשת סעדים לצו מניעה ופיצויים.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">9. הגבלת אחריות</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                האתר, השירותים והתכנים ניתנים למשתמש <strong>כמות שהם</strong> (AS IS), <strong>ללא כל התחייבות</strong>, אחריות, מצג או הבטחה מכל סוג מצד מפעיל האתר – בין אם מפורשת ובין אם משתמעת.
              </li>
              <li>
                מפעיל האתר אינו מתחייב לזמינות האתר, נכונות הנתונים, התאמה לצרכי המשתמש, שלמות, עדכניות, איכות, דיוק או היעדר תקלות. השימוש באתר מתבצע על אחריות המשתמש בלבד.
              </li>
              <li>
                מובהר כי מפעיל האתר <strong>אינו מספק ייעוץ השקעות</strong>, ייעוץ פנסיוני, ייעוץ מס או ייעוץ פיננסי מכל סוג, ואין לראות באף מרכיב באתר משום המלצה, חוות דעת, התחייבות לתוצאה או תחליף לייעוץ מוסמך.
              </li>
              <li>
                מפעיל האתר <strong>לא יישא באחריות</strong> בגין כל נזק – ישיר, עקיף, מיוחד, תוצאתי, נלווה, כספי, מוסרי, חוזי, נזיקי או אחר – לרבות (ומבלי לגרוע) אובדן הכנסה, אובדן רווחים, עוגמת נפש, אובדן נתונים, הפרעות גישה, פרצות אבטחה, או כל תוצאה של שימוש באתר או הסתמכות על תכניו.
              </li>
              <li>
                כל הסתמכות מצד המשתמש על הנתונים, הדירוגים, ההמלצות, ההשוואות או תוצרי האלגוריתם – נעשית על פי שיקול דעתו הבלעדי ובאחריותו המלאה בלבד.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">10. שיפוי</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              המשתמש מתחייב לשפות ולפצות את מפעיל האתר, עובדיו, נושאי המשרה, יועציו, קבלניו, ו/או צדדים שלישיים הקשורים בו – בגין כל תביעה, הוצאה, נזק, הפסד, או דרישה שתתקבל כתוצאה מהפרה של תנאים אלה, שימוש אסור באתר, שימוש שמנוגד לדין, או פגיעה בצדדים שלישיים כתוצאה מפעולתו.
            </p>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">11. סעד ייחודי וויתור תביעות</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                מבלי לגרוע מזכויות אחרות לפי כל דין, מסכים המשתמש כי הסעד הבלעדי והיחיד בגין כל טענה, תביעה או דרישה הנוגעים לשימוש באתר – יהיה הפסקת השימוש באתר.
              </li>
              <li>
                המשתמש מוותר מראש, באופן בלתי חוזר, על כל תביעה, דרישה, טענה, סעד או הליך – כספי או אחר – נגד מפעיל האתר, בכל הקשור לשירותים, לתוכן, לנתונים או לדיוקם, או להסתמכות עליו, לרבות טענות בדבר אחריות מצג, הפרת חובה חקוקה, התרשלות, עוולות מסחריות או כל עילה אחרת.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">12. שינוי התנאים ועדכונם</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                מפעיל האתר שומר לעצמו את הזכות לשנות, לעדכן, להוסיף או לגרוע מתנאים אלה – כולם או חלקם – בכל עת, לפי שיקול דעתו הבלעדי, וללא צורך בהודעה מוקדמת.
              </li>
              <li>
                תנאים מעודכנים ייכנסו לתוקף מיידית עם פרסומם באתר, אלא אם צוין אחרת.
              </li>
              <li>
                המשך השימוש באתר לאחר שינוי התנאים יהווה הסכמה מחודשת מצד המשתמש לתנאים בנוסחם המעודכן.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">13. סיום השירות והגבלת גישה</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                מפעיל האתר שומר לעצמו את הזכות להפסיק, להשעות או לתחום את הגישה לאתר או לשירותים מסוימים, לכל משתמש, בכל עת, לפי שיקול דעתו הבלעדי – וללא צורך בהנמקה או בהודעה מוקדמת.
              </li>
              <li>
                למשתמש לא תהא כל טענה, דרישה או תביעה נגד מפעיל האתר בקשר עם סיום שירות, חסימת גישה או הגבלת שימוש.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">14. תוקף משפטי ואכיפה</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                תנאים אלה מהווים הסכם מחייב על פי כל דין בין המשתמש לבין מפעיל האתר.
              </li>
              <li>
                כל סעיף בתנאים אלה יפורש באופן עצמאי, ואם יימצא על ידי בית משפט מוסמך כי סעיף כלשהו אינו תקף או אינו ניתן לאכיפה – לא יהא בכך כדי לגרוע מתוקפם של יתר הסעיפים.
              </li>
              <li>
                כל ויתור או שיהוי של מפעיל האתר באכיפת זכות מכוח תנאים אלה לא ייחשב כוויתור קבוע, אלא אם נעשה במפורש ובכתב.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">15. הדין החל וסמכות שיפוט</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                תנאים אלה וכל מחלוקת שתצמח מהם או מהשימוש באתר – יפורשו ויוחלו על פי דיני מדינת ישראל בלבד.
              </li>
              <li>
                סמכות השיפוט המקומית והבלעדית בכל עניין ומחלוקת תהיה נתונה לבתי המשפט המוסמכים במחוז תל־אביב–יפו, בלבד.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">16. הצהרות משלימות</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                המשתמש מצהיר כי קרא את התנאים בעיון, הבין את תוכנם, ומסכים לכל תנאיהם באופן מודע, עצמאי וללא כפייה.
              </li>
              <li>
                אין בהסכמה לתנאים אלו כדי ליצור בין המשתמש לבין מפעיל האתר כל מערכת יחסים משפטית מעבר לאמור בהם, לרבות שותפות, שליחות, העסקה או ייצוג.
              </li>
              <li>
                המשתמש אינו רשאי להמחות, להעביר או לשעבד זכויות או חובות מכוח תנאים אלה, מבלי לקבל לכך אישור מראש ובכתב ממפעיל האתר.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">17. תחולה עתידית והרחבה מסחרית</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                תנאים אלה יחולו גם במקרה של הרחבת פעילות האתר בעתיד, לרבות פתיחת אזור אישי, שירותים בתשלום, ממשקי API, הצעות לשירותי ייעוץ, תכניות שותפים, שיתופי פעולה עסקיים, ותוכן ממומן – ככל שיתווספו.
              </li>
              <li>
                כל עוד לא פורסמו תנאים חדשים להרחבות אלה – יחולו התנאים הקיימים בשינויים המחויבים.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">18. שמירת זכויות</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                כל הזכויות באתר אשר לא הוענקו במפורש למשתמש – שמורות למפעיל האתר בלבד.
              </li>
              <li>
                השימוש באתר אינו מקנה למשתמש כל זכות, רישיון או אינטרס כלשהו מעבר לאמור במפורש במסמך זה.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">19. פרשנות וכותרות</h2>
            <ul className="list-decimal list-inside text-gray-700 space-y-2 mb-4">
              <li>
                כותרות הסעיפים נועדו לנוחות בלבד, ולא ישמשו ככלי פרשני לעניין תוכנם או משמעותם של התנאים.
              </li>
              <li>
                בכל מקרה של סתירה בין גרסה בעברית לגרסה בשפה אחרת (אם תפורסם בעתיד) – תגבר הגרסה העברית.
              </li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-800 mt-8 mb-4">20. יצירת קשר</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              בכל שאלה, בירור או פנייה משפטית, ניתן ליצור קשר עם מפעיל האתר דרך{' '}
              <Link to="/contact" className="text-blue-600 hover:text-blue-800">טופס "צור קשר" שבאתר</Link>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;